const getAccessToken = () => {
  try {
    let acquireToken: any = sessionStorage.getItem(
      `msal.token.keys.${process.env.REACT_APP_CLIENT_ID}`
    );
    acquireToken = JSON.parse(acquireToken);
    acquireToken = acquireToken["accessToken"];
    acquireToken = sessionStorage.getItem(acquireToken[0]);
    acquireToken = JSON.parse(acquireToken);
    acquireToken = acquireToken.secret;
    return acquireToken;
  } catch (err: any) {
    return err;
  }
};

export { getAccessToken };
